import React from "react";
import { T } from "../../../app/tokens.js";
import { EVEN_INSTALLMENT_LABEL, EVEN_INSTALLMENT_NOTE, MONTHLY_ACTUAL_LABEL, MONTHLY_ACTUAL_NOTE } from "../../../../shared/leaseMonthlyDisplay.js";

export function MonthlyRentBasis({ derivation }) {
  if (derivation?.amount == null) return null;
  const actual = derivation.basis === "monthly_actual";
  return <span title={actual ? MONTHLY_ACTUAL_NOTE : derivation.approximate ? EVEN_INSTALLMENT_NOTE : undefined}
    style={{ display: "block", fontSize: T.fsXxxs, color: T.mid, fontWeight: T.fwRegular }}>
    {actual ? MONTHLY_ACTUAL_LABEL : derivation.approximate ? EVEN_INSTALLMENT_LABEL : "sourced stepped rent"}
  </span>;
}
